import { ErrorSeverity } from "./ErrorSeverity";

/**
 * Triggered when a recovery attempt is made (e.g. websocket error, camera error, etc.)
 */
export class WebsocketErrorException extends Error {
  useErrorBoundary: boolean;
  message: string;
  domain: string;
  errorSeverity: ErrorSeverity;

  constructor({ message, domain }: { message: string; domain: string }) {
    super("WebsocketErrorException");
    this.name = "WebsocketErrorException";
    this.errorSeverity = ErrorSeverity.ERROR;
    this.useErrorBoundary = false;
    this.message = message;
    this.domain = domain;
  }
}
